export const currentYear = new Date().getFullYear();

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const DocumentPermitteeDetranServiceType = {
  PRIMEIRO_EMPLACAMENTO: { id: 1, value: "PRIMEIRO_EMPLACAMENTO", labelKey: "Primeiro Emplacamento" },
  RENOVAÇÃO: { id: 2, value: "RENOVACAO", labelKey: "Renovação" }
};

export const DocumentPermitteeTransportType = {
  TAXI: "TAXI",
  MOTOTAXI: "MOTOTAXI",
  TRANSPORTE_ESCOLAR: "TRANSPORTE ESCOLAR",
  ONIBUS: "ONIBUS",
  TURISMO: "TURISMO"
};

export const DocumentPermitteeType = {
    LICENCE: {
        value: "ALVARA",
        display: "Alvará",
        expirationDate: `${currentYear}-12-31`,
        observation: `REF. A EMISSÃO DE ALVARÁ DE ${currentYear}.`,
    },
    FIRST_REGISTRATION: {
        value: "PRIMEIRO_EMPLACAMENTO",
        display: "Primeiro Emplacamento",
        observation: `REF. A EMISSÃO DE PRIMEIRO EMPLACAMENTO DE ALUGUEL DE ${currentYear}.`,
    },
    LICENSE_RENEWAL: {
        value: "RENOVACAO_LICENCIAMENTO",
        display: "Renovação de Licenciamento",
        observation: `REF. A EMISSÃO DE RENOVAÇÃO DE LICENCIAMENTO DE ${currentYear}.`,
    },
    TAXIMETER_INSTALLATION: {
        value: "TAXIMETRO",
        display: "Instalação de Taxímetro",
        observation: `REF. A EMISSÃO DE INSTALAÇÃO DE TAXÍMETRO DE ${currentYear}.`,
    },
    TAXIMETER_VERIFICATION: {
        value: "AFERICAO_TAXIMETRO",
        display: "Aferição de Taxímetro",
        observation: `REF. A EMISSÃO DE AFERIÇÃO DE TAXÍMETRO DE ${currentYear}.`,
    },
    IPI_EXEMPTION: {
        value: "ISENCAO_IPI",
        display: "Isenção de IPI",
        observation: `REF. A EMISSÃO DE ISENÇÃO DE IPI DE ${currentYear}.`,
    },
    ICMS_EXEMPTION: {
        value: "ISENCAO_ICMS",
        display: "Isenção de ICMS",
        observation: `REF. A EMISSÃO DE ISENÇÃO DE ICMS DE ${currentYear}.`,
    },
    OWNERSHIP_TRANSFER: {
        value: "TRANSFERENCIA_PROPRIEDADE",
        display: "Transf. de Propriedade",
        observation: `REF. A EMISSÃO DE TRANSF. DE PROPRIEDADE DE ${currentYear}.`,
    },
    CHANGE_TO_RENTAL: {
        value: "MUDANCA_ALUGUEL",
        display: "Mudança para Aluguel",
        observation: `REF. A EMISSÃO DE MUDANLA PARA ALUGUEL DE ${currentYear}.`,
    },
    CHANGE_TO_PRIVATE: {
        value: "MUDANCA_PARTICULAR",
        display: "Mudança para Particular",
        observation: `REF. A EMISSÃO DE MUDANÇA PARA PARTICULAR DE ${currentYear}.`,
    },
    PERMIT_RENEWAL: {
        value: "RENOVACAO_ALVARA",
        display: "Renovação de Alvará",
        expirationDate: `${currentYear}-12-31`,
        observation: `REF. A EMISSÃO DE RENOVAÇÃO DE ${currentYear}.`,
    },
};
